import React from "react";
import { Modal, Button } from "react-bootstrap";
import './PaymentSuccessModal.css'; // Custom CSS

const PaymentSuccessModal = ({ show, handleClose }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="custom-modal-size"
    >
      <Modal.Title className="custom-modal-title">
        Payment Successful
      </Modal.Title>

      <Modal.Body className="custom-modal-body">
        Payment has been processed, please check your Email for further instructions.
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentSuccessModal;
